import { LookupBase } from '@singularsystems/neo-core';

export default class TableLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public readonly tableId: number = 0;

    public readonly tableName: string = "";

    // Client only properties / methods
}